import React from 'react';
import { Flex, Text, Card, Icon } from '@opendoor/bricks/core';
import { InternalLink } from 'platform/react-router';
import { getHubBuyingFeedFiltersRoute } from 'shared/helpers/routes';
import { useDevice } from '@opendoor/bricks/hooks/useMedia';
import {
  MIN_PROPERTY_CARD_HEIGHT,
  MOBILE_PROPERTY_CARD_WIDTH,
} from 'buying/components/propertyCards/PropertyCard';

/** "Expand feed" card for PropertyCardRow */
export const ExpandFeedCard: React.FC = () => {
  const { isMobile, isTablet } = useDevice();

  return (
    <Card
      width={isMobile ? MOBILE_PROPERTY_CARD_WIDTH : '100%'}
      height="100%"
      minHeight={MIN_PROPERTY_CARD_HEIGHT}
      justifyContent="center"
      alignItems="center"
      variant="secondary"
    >
      <Flex flexDirection="column" gridGap={4}>
        <Text fontWeight="bold" size={isTablet ? 's1' : 's3'}>
          Expand your feed results to see more homes
        </Text>
        <InternalLink
          to={getHubBuyingFeedFiltersRoute()}
          analyticsName="expand-feed"
          aria-label="Adjust your feed filters"
        >
          <Flex alignItems="center">
            <Text color="brand50" size="s0" fontWeight="semibold">
              Adjust your feed filters
            </Text>
            <Icon name="chevron-right" color="brand50" size={16} />
          </Flex>
        </InternalLink>
      </Flex>
    </Card>
  );
};
